import styled from 'styled-components'
import { CardTitle } from './CardTitle'

const HomeCard = ({
  cardTitle,
  children
}: {
  cardTitle: string
  children: React.ReactNode
}) => {
  return (
    <Card>
      <CardTitle title={cardTitle} />
      <Content> {children}</Content>
    </Card>
  )
}

const Card = styled.div`
  background-color: white;
  border-radius: 25px;
  padding: 18px 22px;
  min-height: 310px;
  margin-top: 18px;
`

const Content = styled.div`
  min-height: 200px;
`

export default HomeCard
